import { inputFieldStyleClasses } from '../common/formInputClasses';

export const wrapperClasses = 'mt-4 mb-4 pt-1';

export const headerClasses = 'flex items-center justify-between mb-2';

export const titleClasses = 'm-0! text-sm font-bold text-subtle';

export const tableClasses =
  'table demand-studio-medical-bills-table mb-0! ' +
  'border border-border-light border-collapse table-fixed w-full';

export const theadThClasses =
  'bg-primary-surface text-subtle text-xs font-bold uppercase ' +
  'border-b border-t border-border-light ' +
  'border-r border-r-border-light last:border-r-0 ' +
  'align-middle py-2.5 px-2';

export const tdBaseClasses =
  'align-middle py-2.5 px-2 bg-white ' +
  'border-r border-r-border-light border-b border-b-border-light last:border-r-0 ' +
  'focus-within:shadow-[inset_0_0_0_2px_var(--color-primary-tint)] focus-within:bg-surface-light';

export const providerCellClasses = `${tdBaseClasses} bg-surface-light!`;

export const providerInputClasses =
  'block w-full px-1 py-0.5 font-sans text-sm leading-5 text-subtle font-semibold ' +
  'bg-transparent border border-transparent rounded resize-none overflow-hidden ' +
  'focus:outline-none focus:border-primary focus:bg-white';

export const providerInputInvalidClasses = 'border-danger! bg-white';

export const providerErrorClasses = 'block mt-1 px-1 text-xs font-semibold text-danger';

export const providerInputMinHeight = '1.5rem';

export const totalInputClasses =
  `${inputFieldStyleClasses} ` +
  'border-0! shadow-none! bg-transparent! rounded-none! pr-0 pl-6 ' +
  'border-l-0! ml-1';
